import jQuery from 'jquery';
import 'jquery-validate';
import { usernameSuggester } from '@shared/username-suggester';
import { T_ } from '@shared/translation';
import { custom_validation_rules } from './custom-validation-methods';

export default {
  init() {
    const $form = jQuery('#signup-form');
    const $passwordMeter = $form.find('[data-target=password-meter]');
    const $signupPassword = jQuery('#signup-password');

    // apply remove password strength notification if required elements exist
    if ($signupPassword.length > 0 &&
      $passwordMeter.length > 0 &&
      $passwordMeter.find('.password-meter-message').length > 0) {
      $signupPassword.bind('keyup blur', () => {
        if ($signupPassword.val().length < 6) {
          $passwordMeter.attr('data-strength', '');
          $passwordMeter.find('.password-meter-message').html('');
        }
      });
    }

    this.validation($form, custom_validation_rules);
  },
  validation($form, customValidationRules) {
    const self = this;
    const helpMessages = {};
    const $usernameInput = $form.find('[data-target=signup-username]');
    const $signupEmailInput = $form.find('[data-target=signup-email]');
    const $passwordMeter = $form.find('[data-target=password-meter]');
    const $passwordMeterMessage = $form.find('.password-meter-message');

    $form.find('input').each((index, el) => {
      const $input = jQuery(el);

      helpMessages[$input.prop('name')] = {};
      jQuery.each($input.data(), (key, attr) => {
        helpMessages[$input.prop('name')][key] = attr;
      });
    });
    helpMessages.looking_for.required = T_('Please select a role.');
    helpMessages.newuserpasswd.notequal =
        T_('Password should be different from the username');
    helpMessages.newuserpasswd.passworddifferent =
        T_('Password should be different from the email address');
    customValidationRules.validateEmail();
    customValidationRules.validate_username();
    customValidationRules.check_email_same(this.$form);
    customValidationRules.validate_password_strength();
    customValidationRules.not_equal();
    customValidationRules.passwords_match(this.$form);
    customValidationRules.email_not_blocked();

    $form.validate({
      rules: {
        email: {
          maxlength: 100,
          required: true,
          validateEmailAddress: true,
          emailNotBlocked: true,
          remote: {
            dataType: 'json',
            url: '/ajax/check-email-exist.php',
            data: {
              json: true,
              validator: true,
              email() {
                return $signupEmailInput.val();
              },
            },
            beforeSend() {
              $signupEmailInput.parents('.control').addClass('processing');
            },
            complete() {
              $signupEmailInput.parents('.control')
                  .removeClass('processing');
              self.autoFillUsername(
                  $usernameInput,
                  $signupEmailInput.val(),
                );
            },
          },
        },
        newusername: {
          minlength: 3,
          maxlength: 16,
          validateusername: true,
          required: true,
          remote: {
            dataType: 'json',
            url: '/ajax/check-username-exist.php',
            data: {
              json: true,
              validator: true,
              username() {
                return $usernameInput.val();
              },
            },
            beforeSend() {
              $signupEmailInput.parents('.control').addClass('processing');
            },
            complete() {
              $signupEmailInput.parents('.control')
                  .removeClass('processing');
            },
          },
        },
        newuserpasswd: {
          minlength: 6,
          required: true,
          passworddifferent: [$form.find('[data-target=signup-email]').val()],
          validatepasswordstrength: [
            $form.find('[data-target=password-meter]'),
          ],
          notequal: $form.find('[data-target=signup-username]'),
        },
        newuserpasswd1: {
          minlength: 6,
          required: true,
          passwordsmatch: [$form.find('[data-target=signup-password]')],
        },
        looking_for: {
          required: true,
        },
      },
      messages: helpMessages,
      highlight(element) {
        jQuery(element)
            .closest('.control-group')
            .removeClass('success is-valid')
            .addClass('error is-invalid');

        if (element.name === 'newuserpasswd' &&
            $passwordMeter.attr('data-strength') !== 'weak') {
          $passwordMeter.attr('data-strength', '');
          $passwordMeterMessage.text('');
        }
      },
      success(element) {
        jQuery(element)
            .closest('.control-group')
            .removeClass('error is-invalid')
            .addClass('success is-valid');
      },
      errorPlacement(error, element) {
        element.parents('.control-group')
          .addClass('error is-invalid')
          .removeClass('success is-valid')
          .find('.help-inline')
          .append(error);
      },
      submitHandler(form) {
        _lt.push({
          event: 'User Registration',
          user_type: $form.find(":input[name='looking_for']:checked").val(),
        });
        form.submit();
      },
    });
  },
  autoFillUsername(userNameEl, emailInput) {
    usernameSuggester.init();
    usernameSuggester.suggestUsername(emailInput).done((resp) => {
      userNameEl.val(resp.result.recommended_name);
    });
  },
};
